import * as React from 'react';
import { SVGProps } from 'react';

const IconArrowRedoneSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.086 6H3.5a1.5 1.5 0 1 0 0 3H4v1h-.5a2.5 2.5 0 1 1 0-5h5.586L6.793 2.707 7.5 2 11 5.5 7.5 9l-.707-.707L9.086 6Z"
    />
  </svg>
);
export default IconArrowRedoneSizeXs;
